import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import { authFetch } from '../../utils';
import RecipientUserForm from './RecipientUserForm';

const RecipientUserList = ({ refreshKey }) => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingUserId, setEditingUserId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    authFetch(`${API_URL}/recipients`)
      .then(res => res.json())
      .then(setUsers)
      .catch(console.error);
  }, [refreshKey]);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('¿Eliminar este destinatario?');
    if (!confirmDelete) return;

    await authFetch(`${API_URL}/recipients/${id}`, { method: 'DELETE' });
    setUsers(prev => prev.filter(u => u._id !== id));
  };

  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ maxWidth: '768px', margin: '0 auto', padding: '2rem' }}>
      <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem', textAlign: 'center' }}>
        🪪 Destinatarios de avisos
      </h2>

      <button
        onClick={() => setShowCreateForm(true)}
        style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer', marginBottom: '1rem' }}
      >
        ➕ Nuevo destinatario
      </button>

      {showCreateForm && (
        <RecipientUserForm
          user={null}
          onSave={(saved) => {
            setUsers(prev => [...prev, saved]);
            setShowCreateForm(false);
          }}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      <input
        type="text"
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="🔍 Buscar por nombre..."
        style={{
          width: '100%',
          padding: '0.75rem',
          fontSize: '1rem',
          marginBottom: '1.5rem',
          borderRadius: '6px',
          border: '1px solid #ccc'
        }}
      />

      {filteredUsers.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#666' }}>No se encontraron destinatarios.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {filteredUsers.map(user => (
            <li
              key={user._id}
              style={{
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '1.25rem',
                marginBottom: '1rem',
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
              }}
            >
              {editingUserId === user._id ? (
                <RecipientUserForm
                  user={user}
                  onSave={(saved) => {
                    setUsers(prev => prev.map(u => u._id === saved._id ? saved : u));
                    setEditingUserId(null);
                  }}
                  onCancel={() => setEditingUserId(null)}
                />
              ) : (
                <>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <strong>👤 Nombre:</strong> {user.name}
                  </div>
                  <div><strong>📞 Teléfono:</strong> {user.phoneNumber}</div>
                  <div><strong>🏢 Instalación:</strong> {user.facility}</div>
                  <div>
                    <strong>🔔 Alarmas:</strong>{' '}
                    {user.receivesAlarmCalls && '📞 Llamadas '}
                    {user.receivesAlarmSMS && '📩 SMS '}
                    {!user.receivesAlarmCalls && !user.receivesAlarmSMS && '—'}
                  </div>
                  <div><strong>⚠️ Nivel de riesgo SMS:</strong> {user.riskLevelSMS}</div>

                  <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                    <button
                      onClick={() => setEditingUserId(user._id)}
                      style={{
                        padding: '0.5rem 1rem',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      ✏️ Editar
                    </button>
                    <button
                      onClick={() => handleDelete(user._id)}
                      style={{
                        padding: '0.5rem 1rem',
                        backgroundColor: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      🗑 Eliminar
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RecipientUserList;
